import React, { useEffect } from 'react';
import './HomePage.css';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-scroll';

// Preload images to ensure smooth transitions
const images = [
  require('../../assets/studio/1.png'),
  require('../../assets/studio/2.png'),
  require('../../assets/studio/3.png'),
  // require('../../assets/studio/4.png'),
  require('../../assets/studio/1.png'), // Duplicate first image for seamless loop
];

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Preload images
    images.forEach((image) => {
      const img = new Image();
      img.src = image;
    });
  }, []);

  return (
    <div className="homepage">
      {/* Slideshow container */}
      <div className="slideshow">
        {images.map((img, index) => (
          <div 
            key={index} 
            className="slide" 
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </div>

      <header className="header">
        <h1 className="logo1">PRIYA PRATAP MAKEUP STUDIO</h1>
      </header>

      <div className="main-content">
        <div className="content-buttons">
          <button onClick={() => navigate('/portfolio')}>Portfolio</button>
          <button onClick={() => navigate('/nail-art')}>Nail Art</button>
          <button onClick={() => navigate('/academy')}>Academy</button>
          <button onClick={() => navigate('/studio')}>Studio</button>
          <Link to="contact" smooth={true} duration={500} offset={-50}>
            <button>Contact Us</button>
          </Link>
          <button onClick={() => navigate('/about-us')}>About Us</button>
        </div>
        <div className="whatsapp-chat">
          <button onClick={() => window.open('https://wa.me/918279373678', '_blank')}>
            Book Appointment
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomePage;